"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoProducts = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NoProducts = exports.NoProducts = function NoProducts(_ref) {
  var species = _ref.species;
  var Heading = function Heading() {
    switch (species) {
      case 'FELINE':
        return /*#__PURE__*/_react["default"].createElement("h2", null, "What a cat-astrophe!");
      default:
        return /*#__PURE__*/_react["default"].createElement("h2", null, "Oh my dawg!");
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "noProducts"
  }, /*#__PURE__*/_react["default"].createElement(Heading, null), /*#__PURE__*/_react["default"].createElement("p", null, "At first glance it looks like there are no suitable products for your fur baby.", /*#__PURE__*/_react["default"].createElement("br", null), "However, we may still be able to help."), /*#__PURE__*/_react["default"].createElement("p", null, "Please call us and we will see if there is anything special we can dig up."));
};
NoProducts.propTypes = {
  species: _propTypes["default"].oneOf(['CANINE', 'FELINE', 'all'])
};